// eslint-disable-next-line
export const BEFORE_AND_AFTER_CURRENT_PAGE_COUNT = 3;
